export interface Pagination {
    totalCount: number;
	pageSize: number;
	pageNo: number;
	totalPage: number;
}

export const nullPageInfo: any = {
    list: [],
    pagination: {
    	totalCount: 0,
		pageSize: 20,
		pageNo: 1,
		totalPage: 0
    }
}
